var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFulfilmentInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13012_29069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2932 8.94943H16.344V1.38428C16.344 1.0463 16.0704 0.772705 15.7324 0.772705C15.6006 0.772705 1.11954 0.772705 0.72876 0.772705C0.390778 0.772705 0.117188 1.0463 0.117188 1.38428V15.1372C0.117188 15.4747 0.390778 15.7486 0.72876 15.7486H10.6647V20.1611C10.6647 20.4991 10.9387 20.7727 11.2762 20.7727H19.2932C19.6307 20.7727 19.9048 20.4991 19.9048 20.1611V9.561C19.9048 9.22348 19.6307 8.94943 19.2932 8.94943ZM18.6816 19.5496H11.8878V10.1726H18.6816V19.5496ZM1.34033 1.99585H5.57755V7.34146C5.57755 7.83142 6.12167 8.11661 6.5242 7.85324L8.23044 6.73569L9.93698 7.85324C10.3435 8.11951 10.8836 7.82684 10.8836 7.34146V1.99585H15.1208V8.94943H11.2762C10.9387 8.94943 10.6647 9.22348 10.6647 9.561V14.5256H1.34033V1.99585ZM9.66049 6.21017L8.56552 5.49301C8.36227 5.35995 8.09937 5.35965 7.89566 5.49301L6.80054 6.21017V1.99585H9.66049V6.21017Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2471 11.6896C12.4392 11.6896 12.4378 12.9127 13.2471 12.9127H17.3241C18.1319 12.9127 18.1333 11.6896 17.3241 11.6896C16.8953 11.6896 13.6628 11.6896 13.2471 11.6896Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3251 14.2496C16.8963 14.2496 13.6637 14.2496 13.2481 14.2496C12.4359 14.2496 12.4404 15.4726 13.2481 15.4726H17.3251C18.133 15.4726 18.1342 14.2496 17.3251 14.2496Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.324 16.8098H13.247C12.4392 16.8098 12.4377 18.033 13.247 18.033H17.324C18.132 18.033 18.1332 16.8098 17.324 16.8098Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13012_29069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.772705)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFulfilmentInactive);
export default __webpack_public_path__ + "static/media/fulfilment-inactive.11823362f4732bea872d6949ab9c4c56.svg";
export { ForwardRef as ReactComponent };